import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { A11yWidgetComponent } from './shared/a11y-widget/a11y-widget.component';

/**
 * Widget dostępności stoi TUTAJ, a nie w layoutach, i to jest jedyne miejsce, w którym może
 * stać: obie gałęzie `app.routes.ts` (panel i publiczna) siedzą pod własnymi layoutami, więc
 * ten szablon jest jedynym renderowanym na KAŻDEJ trasie. Kolejność też nie jest przypadkiem —
 * widget idzie PO `<router-outlet />`, żeby w tabulacji był ostatni, za treścią strony.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, A11yWidgetComponent],
  template: '<router-outlet /><app-a11y-widget />',
})
export class App {}
